import React from 'react';
import { array, func, string } from 'prop-types';
import {
  SortIcon,
  StyledSortContainer,
  StyledSortDropdown,
  StyledSortInnerContainer,
} from 'apps/journey/pages/career-exploration/components/filters/styled-sort-dropdown';

const SortDropdown = ({
  toggleSort,
  sortOptions,
  sortValues,
  handleChange,
  label,
}) => {
  return (
    <StyledSortContainer>
      <StyledSortInnerContainer propagateClick={!toggleSort}>
        <SortIcon onClick={toggleSort} />
        <StyledSortDropdown
          placeholder={!!sortValues.length && sortValues[0].name}
          placeholderOnly={true}
          multiselect={false}
          carrot={false}
          onChange={(e) => {
            const value = e.target?.getAttribute('value');
            const selectedSortOptions = sortOptions.find(
              ({ name }) => name === value
            );
            handleChange([selectedSortOptions]);
          }}
          contentClassName="sort-dropdown-content"
          options={sortOptions.map(({ name }) => ({
            label: name,
            value: name,
          }))}
          label={label}
        />
      </StyledSortInnerContainer>
    </StyledSortContainer>
  );
};

SortDropdown.defaultProps = {
  sortOptions: [],
  sortValues: [],
  label: 'Sort',
};

SortDropdown.propTypes = {
  toggleSort: func,
  sortOptions: array,
  sortValues: array,
  handleChange: func,
  label: string,
};

export default SortDropdown;
